import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import { Formik } from "formik"
import { useMemo } from "react"
import { Container } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import BottomFormFixed from "../../components/BottomFormFixed"
import Layout from "../../components/Layout"
import { ScrollLayout } from "../../components/ScrollLayout"
import { useCreateResource } from "../../hooks/resources"
import { type Resource } from "../../types"
import { initialValuesResource, validationSchemaResource } from "./ResourceCommon"
import ResourceForm from "./ResourceForm"

export default function ResourceCreate() {
  const createResource = useCreateResource()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesResource(), [])
  const validationSchema = useMemo(() => validationSchemaResource(), [])

  useBreadcrumbs([{ label: "Risorse", href: "/resources/resources" }, { label: "Nuova risorsa" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova risorsa</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createResource.mutateAsync(values as Resource).then((resource: Resource) => {
                navigate(`/resources/resources/${resource.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <ResourceForm />
                </Container>
                <BottomFormFixed url="/resources/resources" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
